import React from 'react';
import { Box, Card, LinearProgress, Typography } from '@mui/material';
import assets from '../../assets';
import versionConfig from '../../configs/versionConfig';
import colorConfigs from '../../configs/colorConfigs';

interface AuthPageFrameProps {
  title: string;
  children: React.ReactNode;
  loading?: boolean;
}

/** Shared, scrollable frame for the signed-out forms. */
export default function AuthPageFrame({ title, children, loading = false }: AuthPageFrameProps) {
  return (
    <Box
      sx={{
        minHeight: '100%',
        width: '100%',
        boxSizing: 'border-box',
        px: { xs: 2, sm: 3 },
        pt: { xs: 2, sm: 'clamp(32px, 8vh, 88px)' },
        pb: { xs: 2, sm: 4 },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: { xs: 2, sm: 3 },
      }}
    >
      <Box
        component="img"
        alt="Premier Biotech logo"
        src={assets.images.pbiologoexpand}
        sx={{ width: '100%', maxWidth: { xs: 260, sm: 360 }, height: 'auto' }}
      />
      <Card
        sx={{
          width: '100%',
          maxWidth: 480,
          boxSizing: 'border-box',
          borderRadius: '18px',
          border: '1px solid #e0e8e6',
          boxShadow: '0 12px 30px rgba(28, 45, 54, 0.13)',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        {loading && <LinearProgress aria-label="Signing in" sx={{
          position: 'absolute', top: 0, left: 0, right: 0, height: 3,
          backgroundColor: 'transparent',
          '& .MuiLinearProgress-bar': { backgroundColor: colorConfigs.tables.headBg },
        }} />}
        <Box sx={{ minHeight: 52, boxSizing: 'border-box', px: 2, py: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Typography component="h1" sx={{ textAlign: 'center', color: colorConfigs.tables.headBg, fontSize: 24, fontWeight: 700 }}>
            {title}
          </Typography>
        </Box>
        <Box sx={{ px: { xs: 2.5, sm: 4 }, pt: 3, pb: { xs: 2.5, sm: 4 } }}>
          {children}
        </Box>
      </Card>
      <Box component="span" sx={{ color: 'text.secondary', fontSize: 14 }}>
        {versionConfig.version}
      </Box>
    </Box>
  );
}
